import React, { HTMLAttributes } from 'react';
import styles from './Loader.module.css';

type Size = 'xs' | 'sm' | 'md' | 'lg';
type Color = 'primary' | 'secondary' | 'accent';

interface LoaderProps extends HTMLAttributes<HTMLDivElement> {
    size?: Size;
    color?: Color;
    centered?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ size = 'sm', color = 'primary', centered = false, ...props }) => {
    return (
        <div
            {...props}
            className={`${styles.loader} ${styles[size]} ${styles[color]} ${props.className} ${
                centered ? styles.centered : ''
            }`}
        >
            <div>
                <div />
                <div />
                <div />
                <div />
            </div>
        </div>
    );
};

export default Loader;
